"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=initializeMultisig2.js.map